<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part11">The Green-Eyed Monster</h1>
<p class="author">Patrick Quentin</p>
<div class="img_container4">
<img alt="Image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?193447d4